/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Templates_Application_ScopeInputs */

const en_tables_templates_application_scope = /** @type {(inputs: Tables_Templates_Application_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application Scope`)
};

const de_tables_templates_application_scope = /** @type {(inputs: Tables_Templates_Application_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application Scope`)
};

/**
* | output |
* | --- |
* | "Application Scope" |
*
* @param {Tables_Templates_Application_ScopeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_templates_application_scope = /** @type {((inputs?: Tables_Templates_Application_ScopeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Templates_Application_ScopeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_templates_application_scope(inputs)
	return de_tables_templates_application_scope(inputs)
});